import { PaymentService } from "../../../../../payments/constants"
import { PRE_PAY_WITH_COLORS, PRE_PAY_WITH_DEFAULT_COLOR } from "../constants"

export const getPrePayWithColor = (prePayWith?: PaymentService) =>
  prePayWith ? PRE_PAY_WITH_COLORS[prePayWith] : PRE_PAY_WITH_DEFAULT_COLOR
